/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import { ITransactionField, TransactionReportCard } from 'ui/structure/TransactionCard';
import ModalWindow from '../ModalWindow/ModalWindow';

import styles from './PaymentAdviceModal.module.css';

import logo from 'assets/icons/sidemenus-PNG/FABLOGO.png';

interface IProps {
  open: boolean;
  data?: ITransactionField[];
  onClose: () => void;
  onSubmit: (type: string) => void;
  submitting: boolean;
}

const PaymentAdviceModal = ({ open, data, onClose, onSubmit, submitting }: IProps) => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <ModalWindow open={open} onClose={handleOnClose} fullScreen large>
      <>
        <NavigationTitle to="#/" onClick={onClose} layoutType={LayoutType.dashboard} className={styles.navTitle}>
          {' '}
        </NavigationTitle>
        {data && (
          <TransactionReportCard
            header={
              <div className={styles.headerContainer}>
                <img src={logo} alt="fab logo" className={styles.img} />
                <p className={styles.fabText}>First Atlantic Bank PLC Payment Advice</p>
              </div>
            }
            fields={data}
            onClose={onClose}
            onSubmit={onSubmit}
            submitting={submitting}
          />
        )}
      </>
    </ModalWindow>
  );
};

export default PaymentAdviceModal;
